export default {
  common_or: 'หรือ',
  common_placeholder_optional: 'ไม่จำเป็นต้องใส่',
  common_button_next: 'ถัดไป',
  common_button_cancel: 'ยกเลิก',
  common_button_skip: 'ข้ามไป',
  common_button_ok: 'ตกลง',
  common_button_back: 'ย้อนกลับ',
  common_button_yes: 'ใช่',
  common_button_no: 'ไม่ใช่',
  common_button_reset: 'Reset',
  common_error_title: 'ข้อผิดพลาด',
  common_error_message_webServiceWrongConnection: 'มีข้อผิดพลาดเกิดขึ้นในระหว่างการถ่ายโอนข้อมูล กรุณาลองใหม่อีกครั้ง',
  common_error_message_noInternetConnection: 'การเชื่อมต่ออินเทอร์เน็ตขาดหายไป กรุณาลองใหม่อีกครั้ง',
  common_error_message_cameraNotAllowed: 'จำเป็นต้องมีสิทธิ์ใช้งานกล้องเพื่อใช้งานการทำงานนี้',
  common_error_message_invalidCredentials: 'โอ๊ะ! ชื่อผู้ใช้งานและ/หรือรหัสผ่านไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง',
  common_error_message_unauthorizedAccess: 'การเข้าถึงที่ไม่ได้รับอนุญาต',
  common_error_message_missingField: 'ช่องที่ต้องใส่',
  common_error_message_incorrectEmail: 'กรุณาใส่อีเมลที่ถูกต้อง',
  common_error_message_invalidMobile: 'Please enter a valid mobile phone number',
  common_error_message_ForbiddenException: 'สิทธิ์ไม่เพียงพอ',
  common_deactivated_title: 'Kiosk deactivated on this device',
  common_deactivated_message:
    'This kiosk has been activated on another device and is thus no longer active on this one. Please log in again. Thank you!',
  common_expired_title: 'Account expired',
  common_expired_message:
    'Either your trial has expired or the credit card we have on file stopped working. Please upgrade in order to re-activate the account. Contact sales@proxyclick.com if you have any questions. Thank you!',
  common_tooltip_gotIt_button: 'เข้าใจแล้ว',
  common_tooltip_disable_button: 'ปิดเคล็ดลับทั้งหมด',
  common_onboarding_message1: 'Proxyclick helps you singleTenantWelcome your visitors exactly the way you want to.',
  common_onboarding_message2:
    'Brand your check-in process and your badges, and ask your visitors only the questions that apply to them.',
  common_onboarding_message3: 'Hosts get notified when their guests arrive and can reply instantly.',
  common_onboarding_message4:
    'Protect your facilities and ensure compliance through emergency lists, watch lists, NDAs, privacy rules ...',
  common_onboarding_message5:
    'Proxyclick does the hard work so you can singleTenantWelcome your visitors with a smile.',
  common_onboarding_login_button: 'Log in',
  common_timeout_title: 'กลับสู่หน้าจอหลัก',
  common_timeout_content: 'แตะเพื่อยกเลิก',
  common_enterEmail_title: 'อีเมลของคุณ',
  common_enterEmail_email: 'กรุณาใส่อีเมลที่ใช้ในทางธุรกิจของคุณ',
  common_signup_title: 'ยินดีต้อนรับสู่ Proxyclick',
  common_signup_name: 'ชื่อ',
  common_signup_name_placeholder: 'ชื่อ นามสกุล',
  common_signup_company: 'บริษัท',
  common_signup_email: 'อีเมล',
  common_signup_password: 'รหัสผ่าน',
  common_signup_tryFree_button: 'ส่ง',
  common_signup_error_name: 'กรุณาใส่ชื่อและนามสกุล',
  common_signup_loading_title: 'กำลังติดตั้งบัญชีของคุณ …',
  common_signup_loading_message1:
    'คุณสามารถปรับแต่งคีออสของคุณได้ด้วยการเชื่อมต่อไปยังเว็บแอ๊ปของ Proxyclick เราเพิ่งจะส่งอีเมลพร้อมรายละเอียดทั้งหมดให้คุณ',
  common_signup_loading_message2: 'จากเว็บไซต์คุณสามารถตั้งค่าเครื่องพิมพ์ของคุณได้เพื่อพิมพ์บัตรตอนลงชื่อเข้า',
  common_signup_loading_message3: 'คุณยังสามารถเปิดใช้งานการแจ้งเตือนให้ส่งไปที่ผู้ดูแลต้อนรับตอนที่ลงชื่อเข้าได้',
  common_signup_loading_message4: 'และปรับแต่งคีออสของคุณด้วยสีและรูปต้อนรับของตนเอง',
  common_setup_login_title: 'เข้าสู่ระบบด้วยบัญชี Proxyclick ของคุณ',
  common_setup_login_email: 'อีเมล',
  common_setup_login_password: 'รหัสผ่าน',
  common_setup_login_forgotPassword_button: 'ลืมรหัสผ่านหรือ?',
  common_setup_login_activationCode_button: 'Activate with unique code?',
  common_setup_activationCode_title: 'Activate kiosk with unique code',
  common_setup_activationCode_code: 'Enter your activation code',
  common_setup_activationCode_code_placeholder: 'Eg. YSSFG-CVWVR-JFRWX-HSNMK',
  common_setup_activationCode_activate_button: 'Activate',
  common_setup_activationCode_footer: 'Activation code is handy for SSO admins or for local guards. Learn More.',
  common_setup_activationCode_error_invalidCode: 'Invalid activation code',
  common_setup_location_title: 'เลือกเว็บไซต์ของคุณ',
  common_setup_location_footer: 'ในการที่จะสร้างเว็บไซต์ใหม่ให้เชื่อมต่อไปยังเว็บแอ๊ปของ Proxyclick',
  common_setup_location_kiosks: 'คีออส',
  common_setup_location_kiosk: 'คีออส',
  common_setup_device_title: 'เลือกคีออสของคุณ',
  common_setup_device_multiTenants: 'กลุ่มบริษัท',
  common_setup_device_footer: 'ในการที่จะสร้างคีออสใหม่ให้เชื่อมต่อไปยังเว็บแอ๊ปของ Proxyclick',
  common_setup_device_locked_title: 'คีออสถูกใช้งานอยู่',
  common_setup_device_locked_content:
    'คีออสนี้ถูกใช้งานอยู่ในไอแพดอีกเครื่อง การตั้งค่าบนไอแพดที่คุณกำลังใช้จะปิดการใช้งานบนอีกเครื่องหนึ่ง คุณแน่ใจว่าต้องการตั้งค่าคีออสบนไอแพดเครื่องนี้หรือไม่?',
  common_setup_device_locked_continue_button: 'ตั้งค่าคีออสนี้',
  common_setup_ready_title: 'สวัสดี {0}',
  common_setup_ready_header: 'พร้อมที่จะตั้งค่าไอแพดเครื่องนี้เป็นคีออส {0} ของคุณหรือไม่?',
  common_setup_ready_message: 'ใช้เวลาเพียงนาทีเดียวเพื่อปรับแต่งค่าแล้วคีออสของคุณก็จะใช้งานได้เลย',
  common_setup_ready_setup_button: 'ตั้งค่า',
  common_setup_loading_title: 'กำลังตั้งค่าคีออสของคุณ...',
  common_setup_loading_message: 'กำลังปรับแต่งค่า...',
  common_setup_loading_footer: 'ในการที่จะปรับแต่งคีออสของคุณให้เชื่อมต่อไปยังเว็บแอ๊ปของ Proxyclick',
  vm_identification_qrCode_button: 'สแกนบัตรเชิญ/บัตรผ่านของคุณ',
  vm_identification_id_button: 'สแกนไอดีของคุณ',
  vm_qrCode_title: 'สแกนบัตรหรือรหัสสมุดของคุณ',
  vm_qrCode_help: 'ถือรหัสของคุณห่างจากกล้องสัก 10-15 ซม.',
  vm_qrCode_not_recognized: 'รหัสที่ไม่รู้จัก',
  vm_multiTenant_title: 'ยินดีต้อนรับ คุณกำลังเยี่ยมชมบริษัทไหนหรือ?',
  vm_welcome_title: 'ยินดีต้อนรับสู่ {{Company_Name}}',
  vm_welcome_hello_line1: 'สวัสดี',
  vm_welcome_hello_line2: 'กรุณาเข้ามาลงชื่อ',
  vm_welcome_qrCode_scan: 'Pre-registered Visitors: hold your QR code up to the camera for check-in or out',
  vm_welcome_qrCode_checkedIn: "Welcome {0}, don't forget to check out before leaving",
  vm_welcome_qrCode_checkedOut: 'Thank you for visiting, {0}!',
  vm_welcome_qrCode_notRecognized: 'This QR code is not recognized. Please try again.',
  vm_welcome_qrCode_wrongCompany: 'Your QR code is invalid for this location.',
  vm_welcome_changeLanguage_button: 'Change Language',
  vm_welcome_checkin_button: 'ลงชื่อเข้า',
  vm_welcome_checkout_button: 'ลงชื่อออก',
  vm_welcome_delivery_button: 'Delivery',
  vm_welcome_returning_button: 'Been here before?',
  vm_welcome_tooltip_title: 'ทำให้เป็นของคุณ',
  vm_welcome_tooltip_content:
    'ในการที่จะปรับแต่งคีออสของคุณให้เข้าสู่ระบบไปยังเว็บแอ๊ปของ Proxyclick เราเพิ่งจะส่งอีเมลพร้อมขั้นตอนให้คุณ ในเว็บแอ๊ปคุณสามารถอัปโหลดโลโก้และภาพพื้นหลังของคุณแล้วก็เลือกสีได้ ดังนั้นคีออสของคุณจึงสะท้อนเอกลักษณ์ของคุณออกมาได้',
  vm_checkin_returning_email: "Hello, what's your email address?",
  vm_checkin_returning_email_notRegistered:
    'We could not find a scheduled visit linked to your email address. Please check with reception or try again with a different email address.',
  vm_checkin_method_name: 'สวัสดี คุณชื่ออะไรหรือ?',
  vm_checkin_method_name_enterFullName: 'กรุณาใส่ชื่อเต็มของคุณ',
  vm_checkin_method_name_invitationQuestion: 'Did you receive an invitation with a QR-code?',
  vm_checkin_method_name_notRegistered_continue: 'ไม่อยู่ในรายชื่อหรือ?',
  vm_checkin_method_name_notRegistered_block: 'ไม่อยู่ในรายชื่อหรือ? กรุณาตรวจสอบกับฝ่ายต้อนรับ',
  vm_checkin_method_tooltip_title: 'การรู้จำผู้เยี่ยมชม',
  vm_checkin_method_tooltip_content:
    'ลงชื่อเข้าเป็น "Justin Diaz" เพื่อดูว่าผู้เยี่ยมชมที่กลับมาหลังจากเคยมาแล้วหรือผู้ที่ลงทะเบียนไว้ล่วงหน้านั้นได้รับการรู้จำอย่างไร\n\nหรือพิมพ์ชื่อสุ่มเพื่อดูว่าผู้เยี่ยมชมที่ไม่ได้คาดไว้ก่อนนั้นถูกเรียกขานอย่างไร',
  vm_checkin_idScan_disclaimer_text:
    'As part of our security policy, we need to verify your identity using your ID. \n\nWe value your privacy, so we will not store the picture of your ID. Reception officers are available to help if you have any questions.',
  vm_checkin_idScan_disclaimer_start_button: "Let's get started",
  vm_checkin_idScan_region_header: 'What region does your ID come from?',
  vm_checkin_idScan_region_0: ' United States',
  vm_checkin_idScan_region_1: ' Canada',
  vm_checkin_idScan_region_2: 'South America',
  vm_checkin_idScan_region_3: ' Europe',
  vm_checkin_idScan_region_4: ' Australia',
  vm_checkin_idScan_region_5: ' Asia',
  vm_checkin_idScan_region_6: ' General Documents',
  vm_checkin_idScan_region_7: ' Africa',
  vm_checkin_idScan_aila_header: 'Please scan your ID',
  vm_checkin_idScan_aila_scan_button: 'Scan ID',
  vm_checkin_idScan_aila_footer: 'This screen is skipped when you use the recommended hardware ({0})',
  vm_checkin_idScan_aila_learnMore: 'Learn more',
  vm_checkin_idScan_front_picture_header_aila: 'Place your ID in the holder so the front faces the camera.',
  vm_checkin_idScan_front_picture_header_noAila: 'Position your ID entirely inside the frame.',
  vm_checkin_idScan_front_picture_take_button: 'Scan front',
  vm_checkin_idScan_back_picture_header_aila: 'Place your ID in the holder so the back faces the camera.',
  vm_checkin_idScan_back_picture_header_noAila: 'Position the back of your ID entirely inside the frame.',
  vm_checkin_idScan_back_picture_take_button: 'Scan back',
  vm_checkin_idScan_match_check: 'Comparing the two pictures',
  vm_checkin_idScan_match_confirm_button: 'Confirm',
  vm_checkin_idScan_match_error_idExpired_header: 'Sorry, your ID seems to have expired.',
  vm_checkin_idScan_match_error_idExpired_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_idNoFace_header: 'Sorry, we could not identify a face on your ID.',
  vm_checkin_idScan_match_error_idNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_pictureNoFace_header: 'Sorry, we could not identify a face on the picture you took.',
  vm_checkin_idScan_match_error_pictureNoFace_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_match_error_default_header: 'Sorry, something went wrong.',
  vm_checkin_idScan_match_error_default_message: 'Ask a receptionist for help or try again.',
  vm_checkin_idScan_editName_title: 'Please fill in your first and last name',
  vm_checkin_idScan_cancel_title: 'Warning',
  vm_checkin_idScan_cancel_message: 'Check-in will be cancelled and you will return to home screen',
  vm_checkin_details_title: 'Please enter your details',
  vm_checkin_details_firstname: 'ชื่อ',
  vm_checkin_details_lastname: 'นามสกุล',
  vm_checkin_details_companyName: 'บริษัท',
  vm_checkin_details_email: 'อีเมล',
  vm_checkin_welcome_firstTime: 'ยินดีต้อนรับ {{Visitor_FirstName}}',
  vm_checkin_welcome_returning: 'ยินดีต้อนรับกลับมา {{Visitor_FirstName}}',
  vm_checkin_welcome_lastVisit_today: 'Your last visit was earlier today',
  vm_checkin_welcome_lastVisit_yesterday: 'Your last visit was yesterday',
  vm_checkin_welcome_lastVisit_date: 'Your last visit was on {0}',
  vm_checkin_host_name: 'คุณกำลังไปเยี่ยมใครหรือ?',
  vm_checkin_host_enterFullName: 'กรุณาใส่ชื่อเต็มของผู้ดูแลต้อนรับ',
  vm_checkin_host_unknown_button: 'ไม่ทราบ',
  vm_checkin_host_notListed_continue: 'ไม่อยู่ในรายชื่อ',
  vm_checkin_host_notListed_block:
    'หากคุณไม่ทราบผู้ดูแลต้อนรับของคุณหรือไม่พบชื่อของเขาในรายชื่อ กรุณาปรึกษากับฝ่ายต้อนรับ',
  vm_checkin_host_tooltip_title: 'การแจ้งเตือนเมื่อแขกมาถึง',
  vm_checkin_host_tooltip_content:
    'พิมพ์ชื่อของคุณที่นี่แล้วเราจะส่งอีเมลแจ้งเตือนที่พนักงานของคุณจะได้รับเมื่อแขกมาถึง',
  vm_checkin_picture_title: 'มาถ่ายรูปกันเถอะ!',
  vm_checkin_picture_take_button: 'ถ่ายภาพ',
  vm_checkin_picture_auto_lookCamera: 'Please look at the camera, we will take your visitor picture',
  vm_checkin_picture_auto_countDown: ' ',
  vm_checkin_picture_auto_stayStill: 'Remain still',
  vm_checkin_picture_auto_pictureTaken: 'Picture taken',
  vm_checkin_picture_tooltip_title: 'คุณสมบัติทางเลือก',
  vm_checkin_picture_tooltip_content:
    'คุณสามารถปรับแต่งคีออสตามความต้องการของคุณได้และเพิ่มหรือลบคุณสมบัติอย่างเช่นการถ่ายภาพแขกหรือพิมพ์บัตรได้ง่าย ๆ',
  vm_checkin_flow_tooltip_title: 'คำถามที่ชาญฉลาด',
  vm_checkin_flow_tooltip_content:
    'ถามอะไรแขกของคุณก็ได้ที่จะพัฒนาประสบการณ์ของพวกเขาหรือทำให้การลงชื่อเข้ามีความปลอดภัยยิ่งขึ้น คุณสามารถเปลี่ยนทิศทางของคำถามได้ตามคำตอบของแขก คำถามที่คุณเห็นนี้เป็นเพียงตัวอย่างสำหรับการสาธิต',
  vm_checkin_flow_error_message_imageNotAvailable: 'โอ๊ะ ภาพไม่พร้อมใช้งานในขณะนี้ (ปัญหาการเชื่อมต่ออินเทอร์เน็ต)',
  vm_checkin_flow_email: 'อีเมล',
  vm_checkin_flow_licensePlate: 'ป้ายทะเบียนรถ',
  vm_checkin_flow_company: 'บริษัท',
  vm_checkin_flow_mobile: 'กรุณาใส่หมายเลขมือถือของคุณ',
  vm_checkin_flow_mobile_info: 'นี้จะใช้ในการติดต่อกับคุณในกรณีฉุกเฉินในขณะที่คุณอยู่ในสถานที่',
  vm_checkin_flow_duration: 'Visit duration',
  vm_checkin_instructions_sign: 'ลงชื่อที่นี่ด้วยนิ้วมือของคุณ',
  vm_checkin_instructions_agreeTerms_button: 'ตกลง',
  vm_checkin_instructions_clearSignature_button: 'ล้าง',
  vm_checkin_instructions_sendCopy_button: 'ส่งสำเนาให้ฉันทางอีเมลด้วย',
  vm_checkin_instructions_sendCopyTo_button: 'สำเนาจะถูกส่งไปยัง {0} (เปลี่ยนแปลง)',
  vm_checkin_instructions_tooltip_title: 'ลงชื่อและประทับตราแล้ว',
  vm_checkin_instructions_tooltip_content:
    'ทำให้แขกของคุณยอมรับกฎการเยี่ยมชมของคุณด้วยการแตะหรือลายเซ็นอย่างง่าย ๆ คุณสามารถปรับเปลี่ยนเงื่อนไขได้ตามประเภทของการลงชื่อเข้าเยี่ยมชม ปรับแต่งคุณลักษณะนี้และอื่น ๆ อีกมากมายในแดชบอร์ดของ Proxyclick',
  vm_checkin_summary_title: 'การเยี่ยมชม {{Company_Name}}',
  vm_checkin_summary_visiting: 'กำลังเยี่ยมชม {0}',
  vm_checkin_summary_meetingTime: 'พบกันเมื่อ {0}',
  vm_checkin_summary_groupStats: 'มาแล้ว {0} คนจาก {1} คน',
  vm_checkin_summary_agreementAlreadySigned: 'Agreement already signed',
  vm_checkin_summary_checkin_button: 'ลงชื่อเข้า',
  vm_checkin_summary_editDetails_button: 'แก้ไขรายละเอียด',
  vm_checkin_summary_reviewDetails_button: 'ตรวจทานรายละเอียดการเยี่ยมชมของฉัน',
  vm_checkin_summary_takeNewPicture_button: 'ถ่ายภาพใหม่',
  vm_checkin_summary_sendPass_button: 'ส่งบัตรผ่านสำหรับการเยี่ยมชมครั้งต่อไปมาที่สมาร์ทโฟนของฉัน',
  vm_checkin_summary_sendPassTo_button: 'บัตรผ่านแบบถาวรจะถูกส่งไปยัง {0} (เปลี่ยนแปลง)',
  vm_checkin_summary_countDown: 'You will be checked in after',
  vm_checkin_saveInfo_title: 'Enter your email',
  vm_checkin_saveInfo_email: 'Save my info to speed up my next check-in',
  vm_checkin_saveInfo_email_placeholder: 'Enter your email address',
  vm_checkin_confirmation_title: 'ขอขอบคุณ!',
  vm_checkin_confirmation_header_withPrint: 'กำลังพิมพ์บัตรของคุณ',
  vm_checkin_confirmation_header_withoutPrint: 'คุณได้ลงทะเบียนแล้ว!',
  vm_checkin_confirmation_message: 'กรุณานั่งลง {{Host_FirstName}} จะมาพบคุณในไม่ช้า',
  vm_checkin_confirmation_takeBackID: "Please don't forget your ID",
  vm_checkin_error_message_unableToCheckIn:
    'มีข้อผิดพลาดเกิดขึ้นในขณะที่กำลังจะเสร็จสิ้นการลงชื่อเข้าของคุณ กรุณาติดต่อฝ่ายต้อนรับ',
  vm_checkout_method_title: 'ลงชื่อออกกันเถอะ',
  vm_checkout_method_name: 'กรุณาใส่ชื่อของคุณเพื่อตรวจสอบ',
  vm_checkout_method_name_notFound: 'ไม่พบ',
  vm_checkout_confirmation_title: 'ขอขอบคุณสำหรับการเยี่ยมชม!',
  vm_checkout_confirmation_header: 'ลาก่อน {{Visitor_FirstName}}!',
  vm_checkout_confirmation_message: 'คุณได้ลงชื่อออกแล้ว เราหวังว่าคุณจะเพลิดเพลินกับการเยี่ยมชม',
  vm_infopack_likeCheckIn: 'Liked this check-in? Tap here to learn more',
  vm_infopack_likeProcess: 'Liked this process? Tap here to learn more',
  vm_infopack_email: 'กรุณาใส่อีเมลของคุณเพื่อที่เราจะได้ส่งข้อมูลเกี่ยวกับ Proxyclick ให้',
  vm_infopack_send_button: 'ส่งข้อมูลให้ฉัน',
  vm_infopack_confirmation: 'ขอขอบคุณ! \nเราได้ส่งข้อมูลไปยัง {0} แล้ว',
  vm_product_footer_partner: "You're using Proxyclick Welcome, brought to you by {0}",
  vm_product_footer_noPartner: "You're using Proxyclick Welcome",
  vm_product_footer_learnMore: 'Learn more',
  dm_delivery_recipient_name: 'แพ็คเกจนี้เหมาะสำหรับใคร?',
  dm_delivery_recipient_unknown_button: 'ไม่ทราบ',
  dm_delivery_confirmation_title: 'ขอขอบคุณ!',
  dm_delivery_confirmation_knownRecipient: '{{Host_Name}} ได้รับแจ้งว่าคุณได้ส่งพัสดุภัณฑ์',
  dm_delivery_confirmation_unknownRecipient:
    'มีการส่งการแจ้งเตือนเพื่อแจ้งให้ {{Company_Name}} คุณส่งแพคเกจสำหรับพวกเขา',
  em_multiTenant_notRegistered_button: 'Tap here to check in manually',
  em_multiTenant_alreadyRegistered_button: 'Tap here if you are an employee or have received a QR code to check in',
  vm_welcome_qrCode_show: 'Employees: scan this QR code with Proovr to check in or check out',
  vm_welcome_touchless_qrCode_show: 'Unregistered Visitors: Scan this QR code for touchless check-in',
  vm_welcome_touchless_unexpected_qrCode_show: 'Scan this QR code with your phone to check in as a visitor',
  vm_welcome_touchless_employee_qrCode_show: 'Scan this QR code with Proovr to check in as an employee',
  vm_welcome_touchless_unexpected_and_employee_qrCode_show:
    'Scan this QR code with Proovr (employees) or your phone (visitors) to check in',
  vm_checkin_video_subtitle: 'Watch the full video to continue your check-in.',
  vm_checkin_video_duration: 'Duration',
  vm_checkin_approval_notapproved_title: 'Dear {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_notapproved_message:
    'We are unable to finalize your check-in at this time. Please contact your host or reach out to reception for assistance.',
  vm_checkin_approval_confirmation_unregistered_title: 'Welcome {{Visitor_FirstName}} {{Visitor_LastName}}',
  vm_checkin_approval_confirmation_unregistered_message:
    'We are unable to check you in at this time. Please contact your host or reach out the reception for assistance.',
  vm_checkin_qrcode_no_checkin_allowed: 'Checkin not allowed. Please contact the reception for assistance.',
  vm_vaccine_certification_intro_question_title: 'Dear visitor, do you have an EU COVID Vaccine Certificate?',
  vm_vaccine_certification_declare_question_title:
    'Dear visitor, please declare whether you have a valid COVID vaccine certificate or a COVID test with a negative result',
  vm_vaccine_certification_scanner_title: 'Please present the QR code of your EU COVID certificate to the camera',
  vm_vaccine_certification_scanner_subtitle:
    'Make sure that your QR code is enlarged and the brightness of your mobile phone is on maximum.',
  vm_vaccine_certification_scanner_donthaveaqrcode: "I don't have a QR code",
  vm_signup_defaultInstruction_name: 'ขั้นตอนในการลงชื่อที่ผู้เยี่ยมชมทั้งหมดต้องทำ',
  vm_signup_defaultInstruction_title: 'กรุณาอ่านและลงชื่อด้านล่าง',
  vm_signup_defaultInstruction_content:
    '<p style="text-align: center;"><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-wearbadge.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-assemblypoint.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nopic.png" width="50"/><img class="instruction-icon" src="http://static.proxyclick.com/_/app/img/safetyIcons/terms/icon-nosmoke.png" width="50"/><br/></p><h1>ขั้นตอนสำหรับผู้เยี่ยมชมและข้อตกลงการรักษาความลับ</h1><p>ยินดีต้อนรับ! เรายินดีที่คุณมาเป็นแขกผู้มาเยือนของ {{Company_Name}} ที่สถานที่ของเรา</p><h2>ขั้นตอนสำหรับสุขภาพและความปลอดภัย</h2><p>ตลอดเวลาการเยี่ยมชมของคุณนั้นเราได้คำนึงถึงความปลอดภัยของคุณ ดังนั้นเราจึงขอให้คุณทำตามเงื่อนไขดังต่อไปนี้:</p><ul><li><b>การเข้าถึงสถานที่</b>นั้นได้รับอนุญาตก็ต่อเมื่อมีพนักงานของ {{Company_Name}} เข้าไปด้วย</li><li>ต้องสวม<b>บัตร</b>ผู้เยี่ยมชมตลอดเวลาและต้องคืนให้แก่ฝ่ายต้อนรับเมื่อออกไป</li><li>ในกรณี<b>ฉุกเฉิน</b>ผู้เยี่ยมชมทั้งหมดต้องออกจากสถานที่โดยทันทีผ่านทางออกที่ใกล้ที่สุดแล้วรายงานตัวที่จุดรวมพลที่กำหนด</li><li>ผู้เยี่ยมชม<b>ห้ามถ่ายภาพ</b> (ทั้งภาพถ่ายและวิดีโอ) ของสิ่งใด ๆ ก็ตามภายในสถานที่หรือพื้นที่แวดล้อมโดยรอบ</li><li><b>ห้ามสูบบุหรี่โดยเด็ดขาด</b>เมื่ออยู่ภายในอาคาร</li></ul><h2>ข้อตกลงว่าด้วยการไม่เปิดเผยข้อมูล</h2><p>ในระหว่างที่คุณเยี่ยมชมสถานที่ของ {{Company_Name}} คุณอาจได้เรียนรู้และ/หรือได้ข้อมูลที่เป็นความลับหรือเป็นกรรมสิทธิ์ของบริษัท (รวมถึงแต่มิจำกัด ข้อมูลที่เกี่ยวข้องกับเทคโนโลยี กระบวนการ อุปกรณ์ แผนภาพ และสเป็ค) ซึ่งมิได้เป็นที่ทราบกันทั่วไป (นับจากนี้จะเรียกโดยรวมว่า &#34;ข้อมูลที่เป็นความลับ&#34;)</p><p>โดยการพิจารณาถึงการได้รับอนุญาตให้เยี่ยมชมสถานที่ของ {{Company_Name}} และการต้อนรับที่มีให้แก่คุณในระหว่างการเยี่ยมชมนั้น คุณได้ตกลงว่าคุณจะไม่</p><p>(ก) เปิดเผยหรือทำให้ข้อมูลที่เป็นความลับใด ๆ ที่ได้เปิดเผยแก่คุณในระหว่างการเยี่ยมชมในครั้งนี้และครั้งต่อ ๆ ไปให้แก่ผู้อื่นได้ทราบ หรือ</p><p>(ข) ใช้งานหรือช่วยให้ผู้อื่นได้ใช้งานหรือพัฒนาต่อยอดข้อมูลที่เป็นความลับใด ๆ ในลักษณะใดก็ตาม</p><p>(ค) ใช้เทคโนโลยีกล้องหรือวิดีโอเพื่อเปิดเผยข้อมูลที่เป็นความลับ</p><p>โดยการลงชื่อในสถานที่แห่งนี้ คุณได้รับทราบและเข้าใจต่อขั้นตอนสำหรับสุขภาพและความปลอดภัยและข้อตกลงว่าด้วยการไม่เปิดเผยข้อมูลที่ได้โพสต์ไปแล้ว</p>',
  vm_vaccine_certification_accessDenied_title: 'Access has been denied',
  vm_vaccine_certification_accessDenied_message:
    "Sorry you don't meet the vaccination requirements to enter the premisses",
  vm_vaccine_certification_accessDenied_button: 'Okay',
};
